export default [
    {
        path: '/specialization',
        name: 'specialization',
        component: () => import('@/views/specialization/add'),
        meta: { pageTitle: 'specialization', breadcrumb: [{ text: 'specialization' }] },
    },

]
